import { render, staticRenderFns } from "./Topic2Model.vue?vue&type=template&id=b418caa8&scoped=true"
import script from "./Topic2Model.vue?vue&type=script&lang=js"
export * from "./Topic2Model.vue?vue&type=script&lang=js"
import style0 from "./Topic2Model.vue?vue&type=style&index=0&id=b418caa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418caa8",
  null
  
)

export default component.exports